import { createContext } from "react";
import type { ClientPrincipal } from "./authClient";

export interface AuthState {
  principal: ClientPrincipal | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  isCoach: boolean;
  isAdmin: boolean;
  isCafeteria: boolean;
}

export const AuthContext = createContext<AuthState | undefined>(undefined);
